/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UserSessionIssuer,
  UserSessionIssuer$inboundSchema,
} from "./usersessionissuer.js";

/**
 * Outcome of consolidating a source user_session_issuer onto a target issuer.
 */
export type MigrateOrganizationUserSessionIssuerResult = {
  /**
   * CIMD allowlist entries moved or merged.
   */
  cimdClientsMigrated: number;
  /**
   * Clients re-pointed to the target.
   */
  clientsMigrated: number;
  /**
   * Consents normalized to the target scope.
   */
  consentsMigrated: number;
  /**
   * A user_session_issuer record.
   */
  issuer: UserSessionIssuer;
  /**
   * Remote-session credentials whose provenance moved.
   */
  remoteSessionsMigrated: number;
  /**
   * User sessions re-pointed to the target.
   */
  sessionsMigrated: number;
  /**
   * True when the source issuer was soft-deleted.
   */
  sourceDeleted: boolean;
};

/** @internal */
export const MigrateOrganizationUserSessionIssuerResult$inboundSchema:
  z.ZodMiniType<MigrateOrganizationUserSessionIssuerResult, unknown> = z.pipe(
    z.object({
      cimd_clients_migrated: z.int(),
      clients_migrated: z.int(),
      consents_migrated: z.int(),
      issuer: UserSessionIssuer$inboundSchema,
      remote_sessions_migrated: z.int(),
      sessions_migrated: z.int(),
      source_deleted: z.boolean(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "cimd_clients_migrated": "cimdClientsMigrated",
        "clients_migrated": "clientsMigrated",
        "consents_migrated": "consentsMigrated",
        "remote_sessions_migrated": "remoteSessionsMigrated",
        "sessions_migrated": "sessionsMigrated",
        "source_deleted": "sourceDeleted",
      });
    }),
  );

export function migrateOrganizationUserSessionIssuerResultFromJSON(
  jsonString: string,
): SafeParseResult<
  MigrateOrganizationUserSessionIssuerResult,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      MigrateOrganizationUserSessionIssuerResult$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'MigrateOrganizationUserSessionIssuerResult' from JSON`,
  );
}
